import ErrorContent from "../ErrorContent/ErrorContent";
import { useAuthTranslation } from "../../services/culture/auth.translations";

export const NotFoundComponent = () => {
  const { t } = useAuthTranslation();

  return <ErrorContent title={t("errors.notFound")} message={t("errors.pageNotFound")} />;
};
